import { Button, Container, useMantineTheme, Text } from "@mantine/core";
import { FormattedMessage, useIntl } from "react-intl";
import { i18n } from "../i18n/langType";

interface FloatingBillingButtonProps {
    onClick: () => void;
}

export function FloatingBillingButton({ onClick }: FloatingBillingButtonProps) {
    const theme = useMantineTheme();
    const intl = useIntl();

    return (
        <Container
            pos="fixed"
            bottom={20}
            left="50%"
            w="90%"
            maw={400}
            px="md"
            style={{
                transform: "translateX(-50%)",
                zIndex: 100,
                pointerEvents: "none", // Allow clicks to pass through container
            }}
        >
            <Button
                onClick={onClick}
                fullWidth
                size="lg"
                radius="xl"
                variant="filled"
                style={{
                    pointerEvents: "auto", // Re-enable clicks on button
                    height: "50px",
                    fontSize: "14px",
                    fontWeight: 600,
                    backgroundColor: "#78B51A",
                    color: "#FAFAFA",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    border: "none",
                    textTransform: "uppercase",
                    borderRadius: "25px", 
                }}
            >
                <Text size="md">
                    <FormattedMessage id={i18n.addEditPersonalInfo} />
                </Text>
                
            </Button>
        </Container>
    );
}